"use client"

// src/components/for.ts
var For = {};

export {
  For
};
//# sourceMappingURL=chunk-EFG6L4QH.mjs.map